import { doc, updateDoc, increment, serverTimestamp } from "firebase/firestore"
export default defineNuxtRouteMiddleware(async to => {
    const route = to
    const db = useFirestore()
    console.log(route.query)
  if (route.query.utm) {
    const ref = doc(db, "UTMLogging", "Stats")
    try {
      await updateDoc(ref, {
        [`${route.query.utm}.numberOfClicks`]: increment(1),
        [`${route.query.utm}.lastClick`]: serverTimestamp()
      })
      console.log("Logged UTM")
    } catch (error) {
      console.log("Error logging utm: ", error)
    }
    const newQuery = to.query
    delete newQuery.utm

    return navigateTo({
        ...to,
        query: newQuery
      })
  } else {
    console.log("No UTM")
  }
  
})
  